import React, { Component } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import toastr from 'toastr';

export default class CorrectionInfoPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: '',
            otherReason: '',
            notes: '',
            correctionDate: dayjs(),
            errors: []
        };
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleDateChange = (date) => {
        this.setState({ correctionDate: date });
    };

    validateForm = () => {
        const errors = [];
        
        if (!this.state.reason.trim()) {
            errors.push('reason');
        }
        
        if (this.state.reason === 'Other' && !this.state.otherReason.trim()) {
            errors.push('otherReason');
        }
        
        if (!this.state.correctionDate || !this.state.correctionDate.isValid()) {
            errors.push('correctionDate');
        }
        
        this.setState({ errors });
        return errors.length === 0;
    };

    handleSubmit = () => {
        if (!this.validateForm()) {
            toastr.error('Please fill in all required fields');
            return;
        }

        const correctionInfo = {
            reason: this.state.reason === 'Other' ? this.state.otherReason.trim() : this.state.reason.trim(),
            notes: this.state.notes.trim(),
            correctionDate: this.state.correctionDate.format('YYYY-MM-DD HH:mm:ss'),
            correctedAt: new Date().toISOString(),
            correctedBy: this.props.userName || 'Unknown User'
        };

        // Call the parent's callback with correction info
        if (this.props.onSubmit) {
            this.props.onSubmit(correctionInfo);
        }
    };

    hasError = (field) => {
        return this.state.errors.includes(field);
    };

    render() {
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onClose}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Correction Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Reason for Correction <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                as="select"
                                name="reason"
                                value={this.state.reason}
                                onChange={this.handleChange}
                                isInvalid={this.hasError('reason')}
                            >
                                <option value="">Select a reason</option>
                                <option value="Sample Information Update">Sample Information Update</option>
                                <option value="Medication Update">Medication Update</option>
                                <option value="Data Entry Error">Data Entry Error</option>
                                <option value="Lab Result Update">Lab Result Update</option>
                                <option value="Patient Information Update">Patient Information Update</option>
                                <option value="Insurance Information Update">Insurance Information Update</option>
                                <option value="Provider Information Update">Provider Information Update</option>
                                <option value="Diagnosis Code Update">Diagnosis Code Update</option>
                                <option value="Other">Other</option>
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                                Please select a reason for correction
                            </Form.Control.Feedback>
                        </Form.Group>

                        {this.state.reason === 'Other' && (
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Specify Reason <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="otherReason"
                                    value={this.state.otherReason}
                                    onChange={this.handleChange}
                                    placeholder="Please specify the reason for correction"
                                    isInvalid={this.hasError('otherReason')}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please specify the reason for correction
                                </Form.Control.Feedback>
                            </Form.Group>
                        )}

                        <Form.Group className="mb-3">
                            <Form.Label>Additional Notes</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="notes"
                                value={this.state.notes}
                                onChange={this.handleChange}
                                placeholder="Enter any additional details about this correction..."
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Correction Date *"
                                    value={this.state.correctionDate}
                                    onChange={this.handleDateChange}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            error={this.hasError('correctionDate')}
                                            helperText={this.hasError('correctionDate') ? 'Please select a valid date' : ''}
                                        />
                                    )}
                                    maxDate={dayjs()}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            error: this.hasError('correctionDate'),
                                            helperText: this.hasError('correctionDate') ? 'Please select a valid date' : ''
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Form.Group>

                        <div className="text-muted small">
                            <i className="fas fa-info-circle"></i> This correction will be logged in the order's correction history.
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.onClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={this.handleSubmit}>
                        Save Correction
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}